import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Cardmaster} from "../models/cardmaster";
import {CardService} from "../services/card.service";
import {ActivatedRoute, Router} from "@angular/router";

declare var $: any;

@Component({
    selector: 'app-addcard',
    templateUrl: './addcard.component.html'
})
export class AddcardComponent implements OnInit {
    title: string = "Add card";
    card_id = 0;
    cardform: FormGroup;
    cardinfo: Cardmaster;
    public allcategories = [];
    public selectedValue;
    public catvalue;
    public pages = [];
    isEdit: boolean = false;
    ckeditorContent;
    isHidden = true;
    defaultValues = {
        card_coin: 0,
        envelope_coin: 0,
        envelope_image_transparent: 'envelope',
        card_photo_count: 0,
        card_type: 0,
        envelope_linear_image: 'linear_default',
        is_backdrop_set: false,
        is_envelope_added: false,
        backdropname: 'backdrop_default',
    }

    constructor(private cardService: CardService,
                private router: Router,
                private fb: FormBuilder,
                private activatedRoute: ActivatedRoute,) {
        activatedRoute.params.subscribe(params => {
            this.card_id = params["id"];
        });
        if (this.card_id > 0) {
            this.isEdit = true;
        }
        if (this.card_id > 0) {
            this.title = "Edit card";
        }
    }

    ngOnInit() {
        this.title;
        this.isEdit;
        this.cardform = this.fb.group({
            card_name: ['', Validators.required],
            category_id: [],
            card_category: ['', Validators.required],
            card_coin: ['', Validators.required],
            card_image_preview: ['', Validators.required],
            envelope_coin: ['', Validators.required],
            envelope_image_transparent: ['', Validators.required],
            card_photo_count: ['', Validators.required,],
            card_type: ['', Validators.required],
            envelope_linear_image: ['', Validators.required],
            card_image_transparent: ['', Validators.required],
            is_backdrop_set: ['', Validators.required],
            is_envelope_added: ['', Validators.required],
            backdropname: ['', Validators.required],
        });
        this.cardform.patchValue(this.defaultValues);

        this.cardService.getCategories().then(data => {
            this.allcategories = data['data'];
            // this.selectedValue = this.allcategories[5];
            // console.log("===================allcategories",this.allcategories)

        });


        if (this.isEdit) {
            this.getCardInfo();
        }
        //this.loadScriptLibrary();
    }

    onSubmit(cardValue) {

        if (this.isEdit) {
            this.updateForm(cardValue);
        } else {
            this.addForm(cardValue);
        }
    }

    addForm(cardValue) {
        $('#save_card').button('loading');
        this.cardService.createCard(cardValue).then(CardData => {
            if (CardData['code'] === 200) {
                $('#save_card').button('reset');
                $.toast({
                    heading: 'Success',
                    text: CardData['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'success'
                });
                this.router.navigate(['/cards']);
            } else {
                $.toast({
                    heading: 'Warning',
                    text: CardData['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'warning'
                });
                $('#save_card').button('reset');
            }
        }).catch(err => {
            if (err['code'] != 200) {
                $.toast({
                    heading: 'Error',
                    text: err['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'error'
                });
            } else {
                $.toast({
                    heading: 'Error',
                    text: 'Server error! Please try again later',
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'error'
                });
            }
            $('#save_card').button('reset');
        });
    }

    updateForm(cardValue) {
        $('#update_card').button('loading');
        cardValue['card_id'] = this.card_id;
        this.cardService.updateCard(cardValue).then(CardData => {
            if (CardData['code'] === 200) {
                $('#update_card').button('reset');
                $.toast({
                    heading: 'Success',
                    text: CardData['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'success'
                });
                this.router.navigate(['/cards']);
            } else {
                console.log(CardData['message']);
                $.toast({
                    heading: 'Warning',
                    text: CardData['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'warning'
                });
                $('#update_card').button('reset');
            }
        }).catch(err => {
            if (err['status'] != 200) {
                $.toast({
                    heading: 'Error',
                    text: err['message'],
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'error'
                });
            } else {
                $.toast({
                    heading: 'Error',
                    text: 'Server error! Please try again later',
                    position: 'top-right',
                    showHideTransition: 'slide',
                    icon: 'error'
                });
            }
            $('#update_card').button('reset');
        });
    }

    getCardInfo = function () {
        this.cardService.getCardInfo(this.card_id).then(data => {
            console.log("CardInfo11=======>", data['data']);
            this.cardinfo = data['data'];
            this.patchForm();
        });


    }

    patchForm() {
        console.log("CardInfoDetails=======>" + this.cardinfo)
        this.cardform.patchValue({
            card_name: this.cardinfo.card_name,
            card_coin: this.cardinfo.card_coin,
            category_id: this.cardinfo.category_id,
            card_image_preview: this.cardinfo.card_image_preview,
            envelope_coin: this.cardinfo.envelope_coin,
            envelope_image_transparent: this.cardinfo.envelope_image_transparent,
            card_photo_count: this.cardinfo.card_photo_count,
            card_type: this.cardinfo.card_type,
            envelope_linear_image: this.cardinfo.envelope_linear_image,
            card_image_transparent: this.cardinfo.card_image_transparent,
            is_backdrop_set: this.cardinfo.is_backdrop_set,
            is_envelope_added: this.cardinfo.is_envelope_added,
            backdropname: this.cardinfo.backdropname,

            //    card_image_preview: this.cardinfo.card_image_preview,

            // vSlug: this.cardinfo.vSlug,
            // tDescription:this.cardinfo.Description,
        })

        this.selectedValue = this.cardinfo.category_id;  //element;

        // this.allcategories.forEach(element => {
        //     if(element.category_id == this.cardinfo.category_id) {
        //         this.selectedValue = element.category_id;  //element;
        //         console.log("33333333333333333333",this.selectedValue)
        //     }
        // });

    }

    public loadScriptLibrary() {
        let body = <HTMLDivElement> document.body;
        let script = document.createElement('script');
        script.innerHTML = '';
        script.src = 'assets/adminlte/plugins/ckeditor/ckeditor.js';
        body.appendChild(script);

        let body2 = <HTMLDivElement> document.body;
        let script2 = document.createElement('script');
        script2.innerHTML = 'CKEDITOR.replace( \'tDescription\' );';
        body2.appendChild(script2);
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/cardsmaster/addcard/addcard.component.ts